import {
  publicHttpClient,
  type AxiosRequestConfig,
} from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { apiRoutes } from './api-routes';

export interface GetStoreRatingParams {
  store_id: number;
  skip?: number;
  limit?: number;
  overall?: number;
  required_text?: boolean;
  required_image?: boolean;
}

export interface StoreRating {
  my_ratings: MyRating[];
  other_ratings: OtherRating[];
}

export interface MyRating {
  overall: number;
  order_code: string;
  store_id: number;
  customer_id: string;
  customer_mobile: string;
  customer_name: string;
  item_info: ItemInfo[];
  image_url: string[];
  comment: string;
  tags: string[];
  display_tags: string[];
  create_at: number;
  update_at: number;
}

export interface ItemInfo {
  id: number;
  price: number;
  customization_total_pay: number;
  quantity: number;
  note: string;
  customizations: any;
  name: string;
}

export interface OtherRating {
  overall: number;
  order_code: string;
  store_id: number;
  customer_id: string;
  customer_mobile: string;
  customer_name: string;
  item_info: ItemInfo[];
  image_url: string[];
  comment: string;
  tags: string[];
  display_tags: string[];
  create_at: number;
  completed_time: number;
  update_at: number;
}

export const getStoreRatingFn = async (
  token: string,
  params: GetStoreRatingParams,
  config: AxiosRequestConfig = {}
): Promise<StoreRating> => {
  const response = await publicHttpClient.get<StoreRating>(
    apiRoutes.ahafood.store.get_rating,
    {
      params,
      headers: { Authorization: `Bearer ${token}` },
      ...config,
    }
  );

  return response?.data;
};

export const useGetStoreRating = (
  token: string,
  params: GetStoreRatingParams,
  opts?: Omit<UseQueryOptions<StoreRating, Error>, 'queryKey' | 'queryFn'>
) => {
  return useQuery<StoreRating, Error>({
    queryKey: [apiRoutes.ahafood.store.get_rating, params],
    queryFn: () => getStoreRatingFn(token, params),
    ...opts,
  });
};
